export function assignExcept(target: any, source: any, ...except: string[]) {
  for (const key in source) {
    if (except.includes(key)) continue
    target[key] = source[key]
  }
  return target
}
